{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/more",
	"title": "More",
	"category": "design",
	"description": "Content before this block is shown in the excerpt on blog and archive pages. Where a theme shows the full content instead, visitors get a “Read more” link to the rest of the post.",
	"keywords": [ "read more" ],
	"textdomain": "default",
	"attributes": {
		"customText": {
			"type": "string",
			"default": "",
			"role": "content"
		},
		"noTeaser": {
			"type": "boolean",
			"default": false
		}
	},
	"supports": {
		"customClassName": false,
		"className": false,
		"html": false,
		"multiple": false,
		"visibility": false,
		"interactivity": {
			"clientNavigation": true
		},
		"customCSS": false
	},
	"editorStyle": "wp-block-more-editor"
}
